import React from 'react';
import { Calendar, CalendarProps } from 'primereact/calendar';

type Props = CalendarProps & {
  className?: string;
  inputClassName?: string;
};

const defaultWrapperClass =
  '!h-[34px] border-[1px] flex cursor-pointer border-f-black-5 shadow-sm shadow-black/2 bg-white text-md select-none focus-within:border-f-purple focus-within:formica-shadow items-center justify-start rounded-[4px] relative w-full group hover:border-f-purple';

const defaultInputClass = 'p-1 !shadow-none';

function FormicaCalendarComponent({ className, inputClassName, ...rest }: Props) {
  const mergedClassName = className ? `${defaultWrapperClass} ${className}` : defaultWrapperClass;
  const mergedInputClassName = inputClassName ? `${defaultInputClass} ${inputClassName}` : defaultInputClass;

  return <Calendar className={mergedClassName} inputClassName={mergedInputClassName} {...rest} />;
}

export default FormicaCalendarComponent;
